import { Box, Card, CardMedia, Grid, Typography } from "@mui/material";
import Cookies from "js-cookie";
import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logoImage from "../../assets/logo-icon.png";
import CustomModel from "../../components/library/CustomModel";
import FormikForm from "../../components/library/FormikForm";
import Loader from "../../components/loader";
import { PostApi } from "../../services/ApiService";
import { getUserDetails } from "../../utils/utils";
import RememberMe from "./RememberMe";

export default function Login() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { token } = getUserDetails();

  const allFields = [
    {
      fieldName: "email",
      fieldLabel: "Email",
      fieldType: "email",
      initialValue: Cookies.get("email"),
    },
    {
      fieldName: "password",
      fieldLabel: "Password",
      fieldType: "password",
      initialValue: Cookies.get("password"),
    },
  ];

  const ForgetPasswordFields = [
    { fieldName: "email", fieldLabel: "Email", fieldType: "email" },
  ];

  const login = async (data) => {
    try {
      setloading(true);
      let response = await PostApi(`/user/checkAuth`, data);
      if (response?.status === "success") {
        if (rememberMe) {
          Cookies.set("email", data?.email, { expires: 365 });
          Cookies.set("password", data?.password, { expires: 365 });
          Cookies.set("rememberMe", true, { expires: 365 });
        } else {
          Cookies.remove("email");
          Cookies.remove("password");
          Cookies.remove("rememberMe");
        }

        let Item =
          response && response.data && response.data.length > 0
            ? response.data[0]
            : "";

        if (Item) localStorage.setItem("ufxDetails", JSON.stringify(Item));
        navigate("/inspection-details");
      }

      setloading(false);
    } catch (error) {
      setloading(false);
      console.log(error);
    }
  };

  const forgotPassword = async (data) => {
    try {
      setloading(true);
      let response = await PostApi(`/user/sendForgetPassword`, data);
      if (response?.status === "success") {
        toast.success(data.message || "Password sent to your email address");
      }
      setloading(false);
    } catch (error) {
      setloading(false);
      console.log(error);
    }
  };

  function content() {
    return (
      <Grid container justifyContent={"space-between"} alignItems={"center"}>
        <Grid item md={4} sm={4} xs={12}>
          <RememberMe setRememberMe={setRememberMe} rememberMe={rememberMe} />
        </Grid>
      </Grid>
    );
  }

  useEffect(() => {
    if (token) navigate("/inspection-details");
  }, []);

  return (
    <>
      {/* Application loader */}
      {loading && <Loader />}

      <Box
        className="Center"
        sx={{
          background: "#ebebeb",
          height: "92vh",
          padding: 2,
        }}
      >
        <Card sx={{ padding: 5 }}>
          <Box
            sx={{
              mb: 3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CardMedia
              sx={{ width: 100, height: 100, mb: 2 }}
              component="img"
              image={logoImage}
              alt="Fox Pool Logo"
            />
            <Typography variant="h3" component="h2">
              Fox Pool
            </Typography>
            <Typography variant="h5" component="h4">
              Managment
            </Typography>
          </Box>

          <FormikForm
            allFields={allFields}
            buttonTitle={"Login"}
            fullScreen={true}
            isEditModel={true}
            content={content}
            formMethod={login}
          />
        </Card>
      </Box>
    </>
  );
}
